export const getKaMetlhaFuneralClaim = (state) => state.kaMetlhaFuneralClaim;
